<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
</div>
<div class="container-custom-content">

    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Id, Descripción, etc..." #input>
                </mat-form-field>
                <div class="mat-table-procesos">
                    <table mat-table matTableResponsive [dataSource]="dataSource" matSort matSortActive="descripcion"
                        matSortDirection="asc">

                        <ng-container matColumnDef="idPais">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.IdPais}}
                            </th>
                            <td mat-cell *matCellDef="let proceso">
                                {{proceso.idPais}} </td>
                        </ng-container>

                        <ng-container matColumnDef="codigo">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Codigo}}
                            </th>
                            <td mat-cell *matCellDef="let proceso">
                                {{proceso.codigo}} </td>
                        </ng-container>


                        <ng-container matColumnDef="descripcion">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.Descripcion}}
                            </th>
                            <td mat-cell *matCellDef="let proceso" data-label="Descripción">
                                {{proceso.descripcion}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="fechaInicio">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.FechaInicio}}
                            </th>
                            <td mat-cell *matCellDef="let proceso" data-label="Descripción">
                                {{proceso.fechaInicio | date:'dd/MM/yyyy hh:mm:ss'}}
                            </td>
                        </ng-container>


                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let proceso; columns: displayedColumns;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>
</div>